import { Component, ViewChild } from '@angular/core';
import { DesktopSidebarComponent } from "../../../../shared/components/desktop-sidebar/desktop-sidebar.component";
import { DesktopTopbarComponent } from "../../../../shared/components/desktop-topbar/desktop-topbar.component";
import { MobileTopbarComponent } from "../../../../shared/components/mobile-topbar/mobile-topbar.component";
import { TabButtonComponent } from "../../../../shared/components/tab-button/tab-button.component";
import { TranslocoPipe } from '@jsverse/transloco';
import { CustomFooterComponent } from "../../../../shared/components/custom-footer/custom-footer.component";
import { GreenMobilityCardComponent } from "../../components/green-mobility-card/green-mobility-card.component";
import { CalendlyGreenMobilityDialogComponent } from "../../components/calendly-green-mobility-dialog/calendly-green-mobility-dialog.component";

@Component({
  selector: 'app-services-green-mobility-page',
  standalone: true,
  imports: [DesktopSidebarComponent, DesktopTopbarComponent, MobileTopbarComponent, TabButtonComponent, TranslocoPipe, CustomFooterComponent, GreenMobilityCardComponent, CalendlyGreenMobilityDialogComponent],
  templateUrl: './services-green-mobility-page.component.html',
  styleUrl: './services-green-mobility-page.component.css'
})
export class ServicesGreenMobilityPageComponent {
  selectedSidebarItemId: number = 3;

  fleetCarsBetweenLocations: boolean = true;

  numberOfEmployeesInput: string = '';
  numberOfEmployeesInputError: string | null = null;

  numberOfVehiclesInput: string = '';
  numberOfVehiclesInputError: string | null = null;

  // Talk to specialist dialog
  @ViewChild(CalendlyGreenMobilityDialogComponent) talkToSpecialistDialog!: CalendlyGreenMobilityDialogComponent;

  talkToSpecialist() {
    this.talkToSpecialistDialog.openModal();
  }
}
